import { useEffect, useRef, useState } from 'react';
import type { MobileNavigationItem } from './types';

export default function useMenuPath(rootItems: MobileNavigationItem[]) {
  const [branches, setBranches] = useState<MobileNavigationItem[]>([]);
  const levelRef = useRef<HTMLDivElement>(null);
  const focusSelectorRef = useRef<string | null>(null);

  const current = branches[branches.length - 1];
  const parent = branches[branches.length - 2];
  const level = current ? current.children : rootItems;

  // Switching levels unmounts the clicked button, so move focus once the new level renders.
  useEffect(() => {
    const selector = focusSelectorRef.current;
    focusSelectorRef.current = null;
    if (selector)
      levelRef.current?.querySelector<HTMLElement>(selector)?.focus();
  }, [branches]);

  function openBranch(item: MobileNavigationItem) {
    focusSelectorRef.current = '[data-menu-back]';
    setBranches([...branches, item]);
  }

  function goBack() {
    focusSelectorRef.current = `[data-menu-branch="${CSS.escape(current.id)}"]`;
    setBranches(branches.slice(0, -1));
  }

  return { levelRef, current, parent, level, openBranch, goBack };
}
